module.exports = __webpack_public_path__ + "img/home-intro-img.b7e580ba.png";